"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIMovetexPlanningChangedDeliveryOrder = void 0;
const imovetex_planning_changed_planning_1 = require("./imovetex-planning-changed-planning");
function parseIMovetexPlanningChangedDeliveryOrder(data) {
    if (data.planning !== null && typeof data.planning === 'object')
        data.planning = data.planning.map((x) => (0, imovetex_planning_changed_planning_1.parseIMovetexPlanningChangedPlanning)(x));
    return data;
}
exports.parseIMovetexPlanningChangedDeliveryOrder = parseIMovetexPlanningChangedDeliveryOrder;
